<template>
  <div
    v-show="show"
    class="modal"
    @click.self="$emit('close')"
  >
    <div
      class="content"
      :class="{ mobile: isMobileWidth }"
    >
      <slot />
      <CrossIcon
        v-if="withCloseButton"
        class="close-btn"
        @click="$emit('close')"
      />
    </div>
    <slot name="outer" />
  </div>
</template>

<script>
import isMobile from '~/mixins/responsive';
import CrossIcon from '~/components/Common/Svg/CrossIcon.vue';

export default {
  components: {
    CrossIcon,
  },
  mixins: [isMobile],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    close: {
      type: Function,
      required: false,
      default: () => {},
    },
    withCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  watch: {
    show(show) {
      document.body.style.overflow = show ? 'hidden' : 'auto';
    },
  },
  beforeUnmount() {
    document.body.style.overflow = 'auto';
  },
};
</script>

<style lang="scss" scoped>
@import './ModalWindow.scss';
</style>
